// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2415":"c8e621cc002a0113","3402":"6fbaff4543519ed5"}[chunkId] + ".css";
};